import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Form, FormProps, Header, Segment } from "semantic-ui-react";
import { useFormData } from "../hooks/formHooks";
import { restRequest } from "../http";
import { ChangePasswordData } from "../models/user_model";
import { fieldError } from "../utils";

export function ForceChangePasswordComponent(props: {}) {
    const [data, setField, setData] = useFormData<ChangePasswordData>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const history = useHistory()

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.preventDefault();

        setLoading(true);

        restRequest<ChangePasswordData>('auth/password', data, 'post').then(result => {
            let lastRoute = localStorage.getItem('last_route') || '/';

            if (lastRoute.startsWith('/login') || lastRoute.startsWith('/force_change_password')) {
                lastRoute = '/'
            }
            history.push(lastRoute);

            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }


    return <>
        <div style={{ padding: '1rem' }}>
            <Header attached="top">You Must Change Password First</Header>
            <Segment attached="bottom" compact basic loading={loading}>
                <Form onSubmit={onSubmit} loading={loading}>
                    <Form.Group widths="equal">
                        <Form.Input label="New Password" type="password" name="password" value={data['password'] || ''} onChange={setField} required error={fieldError('password', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="Confirm New Password" type="password" name="confirm_password" value={data['confirm_password'] || ''} onChange={setField} required error={fieldError('confirm_password', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <div>
                        <Button primary>Submit</Button>
                    </div>
                </Form>
            </Segment>
        </div>
    </>
}